import { UrlSlug } from '@repo/sanity/types'
import { FunctionComponent } from 'react'
import { PageDto } from '../../types/page.types'
import AddToWishlistIcon from '../sections/wishlist/AddToWishlistIcon'

interface Props {
  pageDto: PageDto
  urlSlug: UrlSlug['current']
}

const ProductGridAddToWishlistIcon: FunctionComponent<Props> = ({ pageDto, urlSlug }) => {
  return (
    <AddToWishlistIcon
      pageDto={pageDto}
      urlSlug={urlSlug}
      className='focus-visible:outline-hidden relative -top-px flex w-2/12 max-w-[2rem] flex-none justify-end transition-opacity ease-out lg:opacity-0 lg:focus-visible:opacity-100 lg:group-hover/item:opacity-100 lg:group-focus-visible/info:opacity-100'
    />
  )
}

export default ProductGridAddToWishlistIcon
